import * as m from "#/paraglide/messages";
import {
  createBackendFailureMessageResolver,
  readBackendFailure,
} from "#/shared/lib/backend-api";

import {
  createPickerTokenOperation,
  type CreatePickerTokenOperation,
} from "../api/create-picker-token";
import {
  getSettingsOperation,
  type GetSettingsOperation,
} from "../api/get-settings";
import {
  putSettingsOperation,
  type PutSettingsOperation,
} from "../api/put-settings";
import {
  saveSettingsLogoOperation,
  type SaveSettingsLogoOperation,
} from "../api/save-settings-logo";

const resolveReadMessage =
  createBackendFailureMessageResolver<GetSettingsOperation>({
    forbidden: () => m.settings_failure_forbidden(),
    network: () => m.settings_failure_network(),
    rejected: () => m.settings_failure_rejected(),
    schema: () => m.settings_failure_schema(),
    unexpected: () => m.settings_failure_unexpected(),
  });

const resolveSaveMessage =
  createBackendFailureMessageResolver<PutSettingsOperation>({
    forbidden: () => m.settings_failure_forbidden(),
    network: () => m.settings_failure_network(),
    // 保存被拒多半是字段没过后端校验，文案要和读失败区分开。
    rejected: () => m.settings_save_failure_rejected(),
    schema: () => m.settings_failure_schema(),
    unexpected: () => m.settings_save_failure_unexpected(),
  });

/** 读配置失败时的文案；不是本 feature 的失败返回 null。 */
export function readSettingsFailureMessage(error: unknown): string | null {
  return resolveReadMessage(readBackendFailure(error, [getSettingsOperation]));
}

const resolveLogoMessage =
  createBackendFailureMessageResolver<SaveSettingsLogoOperation>({
    forbidden: () => m.settings_failure_forbidden(),
    network: () => m.settings_failure_network(),
    // 后端拒收只有两种原因：太大、格式不认。两句话都要说清怎么改。
    rejected: (failure) =>
      failure.status === 413
        ? m.settings_logo_failure_too_large()
        : m.settings_logo_failure_type(),
    schema: () => m.settings_failure_schema(),
    unexpected: () => m.settings_logo_failure_unexpected(),
  });

/** 传 Logo 失败时的文案。 */
export function readSaveLogoFailureMessage(error: unknown): string | null {
  return resolveLogoMessage(
    readBackendFailure(error, [saveSettingsLogoOperation]),
  );
}

/** 保存失败时的文案。 */
export function readSaveSettingsFailureMessage(error: unknown): string | null {
  return resolveSaveMessage(readBackendFailure(error, [putSettingsOperation]));
}

const resolvePickMessage =
  createBackendFailureMessageResolver<CreatePickerTokenOperation>({
    forbidden: () => m.settings_failure_forbidden(),
    network: () => m.settings_failure_network(),
    // 404 是规则不在已保存配置、409 是类型已改或并发签发，
    // 对商家都是「先刷新再试」。
    rejected: () => m.settings_proactive_pick_failure_rejected(),
    schema: () => m.settings_failure_schema(),
    unexpected: () => m.settings_proactive_pick_failure_unexpected(),
  });

/** 签发拾取令牌失败时的文案。 */
export function readPickElementFailureMessage(error: unknown): string | null {
  return resolvePickMessage(
    readBackendFailure(error, [createPickerTokenOperation]),
  );
}
